@use '../../../../design-tokens/typography/typography' as *;

@layer design-system {
  .gridLinesGroup {
    text {
      @include typography-v2-body-xs;
      fill: var(--text-soft);
      font-family: var(--font-roboto-mono);
    }

    line {
      stroke: var(--border-soft);
    }
  }

  .yAxisLabel {
    fill: var(--text-soft);
    font-family: var(--font-nort);
    @include typography-v2-body-xs;
    rotate: -90deg;
    text-anchor: middle;
  }
}
